import React, { lazy, Suspense } from 'react';
import { Route, Switch, useHistory } from 'react-router-dom';

// Lazy load components
const ProductList = lazy(() => import('../Pages/ProductList'));
const AddProduct = lazy(() => import('../Pages/AddProduct'));
const EditProduct = lazy(() => import('../Pages/EditProduct'));
const ProductView = lazy(() => import('../Pages/ProductView'));
const ProductLabel = lazy(() => import('../Pages/ProductLabel'));

// Import loading overlay
import LoadingOverlay from 'react-loading-overlay';
import FadeLoader from 'react-spinners/FadeLoader';
LoadingOverlay.propTypes = undefined;

// Import CSS
import '../Assets/css/product.scss';

function ProductRoute() {
  const history = useHistory();
  
  return (
    <Switch>
      <Route
        exact
        path="/:lng/stock/products"
        render={() => (
          <Suspense fallback={<Loading />}>
            <ProductList history={history} />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/:lng/stock/products/list"
        render={() => (
          <Suspense fallback={<Loading />}>
            <ProductList history={history} />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/:lng/stock/products/add"
        render={() => (
          <Suspense fallback={<Loading />}>
            <AddProduct history={history} />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/:lng/stock/products/edit/:slack"
        render={() => (
          <Suspense fallback={<Loading />}>
            <EditProduct history={history} />
          </Suspense>
        )}
      />
      <Route
        exact
        path="/:lng/stock/products/view/:slack"
        render={() => (
          <Suspense fallback={<Loading />}>
            <ProductView history={history} />
          </Suspense>
        )}
      />

    </Switch>
  );
};

export default ProductRoute;

function Loading() {
  return (
    <>
      <div className="wrapper">
        <span>Loading</span>
      </div>
    </>
  );
}
